export enum FeePosition {
    FrontLeft = 'front_left',
    FrontRight = 'front_right',
    RearLeft = 'rear_left',
    RearRight = 'rear_right',
    Front = 'front',
    Rear = 'rear',
    Center = 'center',
    RearCenter = 'rear_center',
    Left = 'left',
    Right = 'right',
}

export const FeePositionLabel: Record<FeePosition, string> = {
    [FeePosition.FrontLeft]: 'Avant gauche',
    [FeePosition.FrontRight]: 'Avant droit',
    [FeePosition.RearLeft]: 'Arrière gauche',
    [FeePosition.RearRight]: 'Arrière droit',
    [FeePosition.Front]: 'Avant',
    [FeePosition.Rear]: 'Arrière',
    [FeePosition.Center]: 'Centre',
    [FeePosition.RearCenter]: 'Arrière centre',
    [FeePosition.Left]: 'Gauche',
    [FeePosition.Right]: 'Droite',
}